import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useRef, useState } from 'react';
import _, { isArray } from 'lodash';
import BaseModal from 'components/BaseModal';
import { LoadingIcon } from 'components/Icons';
import message from "components/CustomMessage";

function SlackOAuthPopup({ afterClose: _afterClose }, ref) {
    const [error, setError] = useState(false);
    const [failed, setFailed] = useState(true);
    const thisRef = useRef();

    useImperativeHandle(ref,() => ({
        ...thisRef
    }))

    const afterClose = useCallback(() => {
        _afterClose && _afterClose(!failed);
    }, [_afterClose, failed]);

    useEffect(() => {
        const _window = window.open("/user/tools/slack/oauth/start", "_blank", "width=1000,height=800,rel=noopener");
        if(_.isNull(_window)){
            message.error("Pop-up window is blocked on your browser, please enable and retry.");
            afterClose()
            return false;
        }
        var timer = setInterval(function() { 
            try {
                // _window becomes null if the popup window is blocked by the browser.
                // User closes the OAuth window before access
                if(!_window || _window.closed) {
                    clearInterval(timer);
                    message.error("Unable to connect to Slack, please try again.");
                    thisRef.current.close();
                    return;
                }
                if(_window.location.pathname.endsWith("oauth_redirect")){
                    if(error){
                        const bodyTextParsed = JSON.parse(_window.document.body.innerText);
                        if(bodyTextParsed?.success || isArray(bodyTextParsed)) {
                            setFailed(false);
                        }
                        _window.close();
                        clearInterval(timer);
                        thisRef.current.close();
                    }
                }
            } catch (e) {setError(true)}
        }, 1000);
        return () => {
            clearInterval(timer);
            _window.close();
        }
    }, [error, afterClose]);

    return (
        <BaseModal
            modalProps={{
                title: "Connecting Slack",
                footer: null
            }}
            ref={thisRef}
            afterClose={afterClose}
        >
            <LoadingIcon /> Waiting for Slack OAuth.
        </BaseModal>
    )
}

export default forwardRef(SlackOAuthPopup);